import { SuperAdminRole, UserEmails, UserIds } from '@/config/constants';
import { ServiceContainer } from '../serviceContainer';
import { UserService } from './userService';

export class PermissionsService {
  private readonly userService: UserService;

  private role: string = '';

  constructor(userService: UserService = ServiceContainer.get(UserService)) {
    this.userService = userService;
  }

  public async initialize(): Promise<void> {
    this.role = await this.userService.getRoleId();
  }

  public canEditQuickbooks(): boolean {
    return (
      this.isSuperAdmin() ||
      this.emailAllowed([UserEmails.HeatherLloyd, UserEmails.CrystalSheridan, UserEmails.EmilyJahnke])
    );
  }

  public isAccounting(): boolean {
    return this.isSuperAdmin() || this.emailAllowed([UserEmails.HeatherLloyd, UserEmails.EmilyJahnke]);
  }

  public canViewAllTransactions(): boolean {
    return this.isSuperAdmin() || this.emailAllowed([UserEmails.HeatherLloyd, UserEmails.CrystalSheridan, UserEmails.EmilyJahnke]);
  }

  public isManager(): boolean {
    return this.isSuperAdmin() || this.emailAllowed([UserEmails.HeatherLloyd]);
  }

  public canViewFundraisingReports(): boolean {
    return this.isSuperAdmin() || this.emailAllowed([UserEmails.ShawnStutzman]);
  }

  public canManageChecklistTemplates(): boolean {
    return this.isSuperAdmin();
  }

  public canManageContructionEvaluationTemplates(): boolean {
    return this.isSuperAdmin() || this.emailAllowed([UserEmails.ShawnStutzman]);
  }

  public canManageImprovementRequests(): boolean {
    return this.isSuperAdmin();
  }

  public canAccessMultipleContacts(): boolean {
    return this.isSuperAdmin() || this.emailAllowed([UserEmails.HeatherLloyd, UserEmails.MattLowell]);
  }

  public canExportTimesheets(): boolean {
    return (
      this.isSuperAdmin() ||
      this.emailAllowed([
        UserEmails.ShawnStutzman,
        UserEmails.HeatherLloyd,
        UserEmails.EmilyJahnke,
        UserEmails.BillClifton,
        UserEmails.CoryAspell,
        UserEmails.CrystalSheridan,
      ])
    );
  }

  public isFieldSuperintendent(userId: string): boolean {
    const fieldSuperIntendentsIDs: Array<string> = [
      UserIds.JohnJordan,
      UserIds.CoryAspell,
      UserIds.RussellCordum,
      UserIds.DerekWestveer,
      UserIds.SurekaRichmond,
      UserIds.TimJohnson,
      UserIds.ShawnStutzman,
    ];
    return fieldSuperIntendentsIDs.includes(userId);
  }

  private emailAllowed(allowedList: string[]): boolean {
    const email = this.userService.getCurrentUser().email;
    return email ? allowedList.includes(email) : false;
  }

  private isSuperAdmin(): boolean {
    if (!this.role) throw new Error('PermissionsService is not initialized');
    return this.role === SuperAdminRole;
  }
}
